import React, { useState } from "react";

import MenuEditorEmployee from "../_menuEditor/menuEditor";
import DownloadPDFModal from "../../../AdminSubapp/MenuPanel/_printMenuModal/MenuPrintModal";

export const MenuComponent = ({
  menu,
  dishes,
  isDishesLoading,
  handleUpdateMenu
}) => {
  const [isEdited, setIsEdited] = useState(false);
  const [isDishesDivVisible, setIsDishesDivVisible] = useState(false);
  const [isDownLoadPDFShown, setDownLoadPDFShown] = useState(false);

  const handleToggleDishesDiv = () => {
    isDishesDivVisible
      ? setIsDishesDivVisible(false)
      : setIsDishesDivVisible(true);
  };

  const handleUpdateSaveMenu = async (originalMenuId, menuEdited) => {
    await handleUpdateMenu(originalMenuId, menuEdited);
    setIsEdited(false);
  };

  // to sort dishes
  const sortDishesByCategory = (a, b) => {
    let A = a.dishBody.category;
    let B = b.dishBody.category;

    if (A > B) {
      if (A === "САЛАТЫ") return -1;
      if (
        A === "ГАРНИРЫ" &&
        B !== "САЛАТЫ" &&
        B !== "1-е БЛЮДА" &&
        B !== "2-е БЛЮДА"
      )
        return -1;
      return 1;
    } else if (B > A) {
      if (B === "САЛАТЫ") return 1;
      if (
        B === "ГАРНИРЫ" &&
        A !== "САЛАТЫ" &&
        A !== "1-е БЛЮДА" &&
        A !== "2-е БЛЮДА"
      )
        return 1;
      return -1;
    } else {
      return 0;
    }
  };

  const dishCategorySwitch = (category) => {
    let working = category.toUpperCase();
    switch (working) {
      case "SOUP":
        return "SOUP";
      case "MAIN":
        return "MAIN";
      case "SALAD":
        return "SALAD";
      default:
        return category;
    }
  };

  const handlePrintMenu = () => {
    setDownLoadPDFShown(true);
  };

  const handleSwitchWebsitePurpose = (purpose) => {
    switch (purpose) {
      case "dailyMenu":
        return "Daily menu";
      case "orderMenu":
        return "Order menu";
      case "static":
        return "Static menu";
      default:
        return "";
    }
  };

  return !isEdited ? (
    <>
      <div className={`menuComponent`}>
        {menu.active && menu.purposeType !== "print" ? (
          <svg
            title="published"
            width="2em"
            height="2em"
            viewBox="0 0 16 16"
            className="activeMenuBadge"
            fill="var(--btn-border-color-green)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4H2.255a7.025 7.025 0 0 1 3.072-2.472 6.7 6.7 0 0 0-.597.933c-.247.464-.462.98-.64 1.539zm-.582 3.5h-2.49c.062-.89.291-1.733.656-2.5H3.82a13.652 13.652 0 0 0-.312 2.5zM4.847 5H7.5v2.5H4.51A12.5 12.5 0 0 1 4.846 5zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5H7.5V11H4.847a12.5 12.5 0 0 1-.338-2.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12H7.5v2.923c-.67-.204-1.335-.82-1.887-1.855A7.97 7.97 0 0 1 5.145 12zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11H1.674a6.958 6.958 0 0 1-.656-2.5h2.49c.03.877.138 1.718.312 2.5zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12h2.355a7.967 7.967 0 0 1-.468 1.068c-.552 1.035-1.218 1.65-1.887 1.855V12zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5h-2.49A13.65 13.65 0 0 0 12.18 5h2.146c.365.767.594 1.61.656 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4H8.5V1.077c.67.204 1.335.82 1.887 1.855.173.324.33.682.468 1.068z"
            />
          </svg>
        ) : null}
        <div className="menuComponent__menuBodyDiv">
          <div className="menuBodyDiv__congifDiv">
            <div className="congifDiv__menuName ">
              <h3 className="menuComponent__subheading">menu name</h3>
              <div>{menu.name ? menu.name : "No name"}</div>
            </div>
            <div className="congifDiv__menuDate">
              <h3 className="menuComponent__subheading">date</h3>
              <div>
                {menu.menuDate
                  ? new Date(menu.menuDate).toLocaleDateString("en-US")
                  : "No date"}
              </div>
            </div>
            <div className="congifDiv__menuDescription">
              <h3 className="menuComponent__subheading">menu description</h3>
              <div style={{ textAlign: "center" }}>
                {menu.description ? menu.description : "no description"}
              </div>
            </div>
            <div className="congifDiv__menuPurposeType">
              <h3 className="menuComponent__subheading">menu type</h3>
              <div style={{ textAlign: "center" }}>
                {menu.purposeType === "website" ? "Website" : "Printed"}
              </div>
            </div>
            {menu.purposeType === "website" ? (
              <div className="congifDiv__menuWebsitePurpose">
                <h3 className="menuComponent__subheading">Purpose</h3>
                <div style={{ textAlign: "center" }}>
                  {handleSwitchWebsitePurpose(menu.websitePurpose)}
                </div>
              </div>
            ) : null}
            {menu.websitePurpose === "orderMenu" ? (
              <div className="congifDiv__sortBy">
                <h3 className="menuComponent__subheading">Sort by</h3>
                <div style={{ textAlign: "center" }}>
                  {menu.sortBy === "subcategory" ? "Subcategory" : "Category"}
                </div>
              </div>
            ) : null}
          </div>
          <h3 className="menuBodyDiv__dishesDiv__heading">
            items
            <button
              className={`menuBodyDiv__dishesDiv__heading__toggleBtn ${
                isDishesDivVisible
                  ? "menuBodyDiv__dishesDiv__heading__toggleBtn--open"
                  : "menuBodyDiv__dishesDiv__heading__toggleBtn--closed"
              }`}
              onClick={() => handleToggleDishesDiv()}
            >
              <svg
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                className="menuBodyDiv__dishesDiv__heading__toggleBtn__svg"
                fill="var(--btn-border-color-blue)"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 5a.5.5 0 0 0-1 0v4.793L5.354 7.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.793V5z"
                />
              </svg>
            </button>
          </h3>
          <div
            className={`menuBodyDiv__dishesDiv ${
              isDishesDivVisible
                ? "menuBodyDiv__dishesDiv--visible"
                : "menuBodyDiv__dishesDiv--hidden"
            }`}
          >
            {menu.dishes &&
              menu.dishes
                .sort(sortDishesByCategory)
                .map((menuDish, index, sortedArray) => (
                  <div
                    className="dishesDiv__dishItem"
                    key={menuDish.dishBody._id}
                  >
                    <div className="dishItem__category">
                      {(sortedArray[index - 1] &&
                        sortedArray[index - 1].dishBody.category) ===
                      menuDish.dishBody.category
                        ? ""
                        : dishCategorySwitch(menuDish.dishBody.category)}
                    </div>
                    <div className="dishItem__name">
                      {menuDish.dishBody.name}
                    </div>
                    <div className="dishItem__price">
                      {menuDish.dishBody.price}&nbsp;$
                    </div>
                    <div className="dishItem_serving">
                      {menuDish.dishBody.serving}&nbsp;g
                    </div>
                    <div className="dishItem__quantity">
                      in stock: {menuDish.quantity}
                    </div>
                  </div>
                ))}
          </div>
        </div>
        <div
          className="menuComponent__controlsDiv"
          style={{ justifyContent: "center" }}
        >
          {menu.purposeType === "print" ? (
            <button
              className="controlsDiv__actionBtn"
              onClick={() => handlePrintMenu()}
            >
              PRINT
            </button>
          ) : (
            <button
              className="controlsDiv__editBtn"
              onClick={() => setIsEdited(true)}
            >
              EDIT
            </button>
          )}
        </div>
      </div>
      {isDownLoadPDFShown ? (
        <DownloadPDFModal
          menu={menu}
          handleShowDownloadPDFModal={() => setDownLoadPDFShown(false)}
        />
      ) : null}
    </>
  ) : (
    <MenuEditorEmployee
      menu={menu}
      dishes={dishes}
      isDishesLoading={isDishesLoading}
      isFromUpdate={true}
      isFromCopy={false}
      originalMenuId={menu._id}
      handleSaveMenu={handleUpdateSaveMenu}
      handleCancel={() => setIsEdited(false)}
    />
  );
};
